export default __webpack_public_path__ + "static/media/bathroom1-before-2048w.98a20e07.webp";